import { render, staticRenderFns } from "./UniInput.vue?vue&type=template&id=28c09e9e&scoped=true&"
import script from "./UniInput.vue?vue&type=script&lang=js&"
export * from "./UniInput.vue?vue&type=script&lang=js&"
import style0 from "./UniInput.vue?vue&type=style&index=0&id=28c09e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c09e9e",
  null
  
)

export default component.exports